// special handling due to mitt issue in typescript
// https://github.com/developit/mitt/issues/60#issuecomment-398296656
// update when fix is released
import * as mittUMD from "mitt/dist/mitt.umd";
import { Emitter } from "mitt";
const mitt = (): Emitter => new mittUMD();

export default mitt;



// WEBPACK FOOTER //
// ./app/javascript/utils/mitt.ts